import { el, setAttr, mount, unmount } from 'redom';

import application from 'application';

import internalEventCodes from 'event-system/codes/internal';

import { decorateWithShowHide } from 'decorators/ui';

import './index.scss';

class SaveButton {

  constructor(configuration) {

    this.type = configuration.type || 'button';
    this.label = configuration.label;
    this.onClick = configuration.onClick;
    this.class = configuration.class || '';
    this.working = false;
    this.clickHandler = this.handleClickEvent.bind(this);
    this.spinner = this.renderSpinner();
    this.displayMode = 'flex';

    this.el = el('button', {
      type: this.type,
      class: 'startup-themed-button save-button ' + this.class,
      id: configuration.id || 'save-button-' + Date.now(),
      onclick: this.clickHandler,
      disabled: configuration.disabled || false
    }, this.label);

  }

  renderSpinner() {

    return el('ht-spinner', { size: 'tiny' });

  }

  async handleClickEvent(event) {

    if (this.isWorking() === true) {
      return;
    }

    this.setWorking();

    try {

      await this.onClick(event);

    } catch (exception) {
      throw exception;
    } finally {
      this.setIdle();
    }

  }

  setWorking() {

    this.working = true;
    this.el.textContent = '';
    mount(this.el, this.spinner);

  }

  isWorking() {

    return this.working;

  }

  setIdle() {

    this.working = false;
    this.el.textContent = this.label;
    unmount(this.el, this.spinner);

  }

  setDisabled(status) {

    setAttr(this.el, {
      disabled: status
    });

  }

  disable() {

    setAttr(this.el, {
      disabled: true
    });

  }

  enable() {

    setAttr(this.el, {
      disabled: false
    });

  }

  update(configuration) {

    if (typeof configuration.label === 'string') {

      this.label = configuration.label;

    }

    if (this.working === false) {
      this.el.textContent = this.label;
    }

    if (typeof configuration.onClick === 'function') {
      this.onClick = configuration.onClick;
    }

    setAttr(this.el, {
      disabled: configuration.disabled
    });

  }

}

export default decorateWithShowHide(SaveButton);